// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1ImoE","notes":"Notes_notes__3gbyX"};